import { render, staticRenderFns } from "./SideBar_Admin.vue?vue&type=template&id=44dd49fa&scoped=true&"
import script from "./SideBar_Admin.vue?vue&type=script&lang=js&"
export * from "./SideBar_Admin.vue?vue&type=script&lang=js&"
import style0 from "./SideBar_Admin.vue?vue&type=style&index=0&id=44dd49fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd49fa",
  null
  
)

export default component.exports